import { Box, Card, Group, Table, Text, ThemeIcon } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';

const data: {
  kind: string;
  rusty: string | number;
  wufoo: string | number;
  formspree: string | number;
}[] = [
  {
    kind: 'Cost (entry plan)',
    rusty: '$210 / year',
    wufoo: '$264 / year',
    formspree: '$180 / year',
  },
  { kind: 'Forms', rusty: 'Unlimited', wufoo: 10, formspree: 5 },
  { kind: 'Entries', rusty: '2,000 / month', wufoo: '1,000 / month', formspree: '200 / month' },
  { kind: 'Users', rusty: 'Unlimited', wufoo: 1, formspree: 1 },
  { kind: 'Reports', rusty: 'Unlimited', wufoo: 'Unlimited', formspree: 'Unlimited' },
  { kind: 'File Storage', rusty: '500 MB / month', wufoo: '1 GB', formspree: '1 GB' },
  { kind: 'File Upload Limit', rusty: '100 MB', wufoo: '25 MB', formspree: '25 MB' },
  { kind: 'API Requests', rusty: 'Unlimited', wufoo: '10,000', formspree: 'Unlimited?' },
  { kind: 'Confirmation Email', rusty: 'check', wufoo: 'check', formspree: 'check' },
  { kind: 'Redirects', rusty: 'check', wufoo: 'check', formspree: 'check' },
  { kind: 'Autoresponse', rusty: 'check', wufoo: 'check', formspree: 'x' },
  {
    kind: 'Captcha',
    rusty: 'Altcha (Private)',
    wufoo: 'reCAPTCHA (Google)',
    formspree: 'reCAPTCHA (Google)',
  },
  { kind: 'Data Retention', rusty: '30 days (free tier)', wufoo: 'Unknown', formspree: 'Unknown' },
];

const NAVY = '#0A192F';

function CellContent({ value, highlight }: { value: string | number; highlight?: boolean }) {
  if (value === 'check') {
    return (
      <Group gap={4} justify="center">
        <ThemeIcon size={18} radius="xl" variant="light" color={highlight ? 'dark' : 'gray'}>
          <IconCheck size={12} />
        </ThemeIcon>
      </Group>
    );
  }
  if (value === 'x') {
    return (
      <Group gap={4} justify="center">
        <ThemeIcon size={18} radius="xl" variant="light" color="gray">
          <IconX size={12} />
        </ThemeIcon>
      </Group>
    );
  }
  return (
    <Text size="sm" ta="center" fw={highlight ? 600 : 400} c={highlight ? undefined : 'dimmed'}>
      {value}
    </Text>
  );
}

export function Plans() {
  return (
    <Card withBorder radius="md" p={0} style={{ overflow: 'hidden' }}>
      <Table verticalSpacing="md" horizontalSpacing="lg" withRowBorders={false} layout="fixed">
        <Table.Thead style={{ backgroundColor: 'var(--mantine-color-gray-0)' }}>
          <Table.Tr>
            <Table.Th />
            <Table.Th>
              <Text size="sm" fw={700} ta="center" c={NAVY}>
                Formshive
              </Text>
            </Table.Th>
            <Table.Th>
              <Text size="sm" fw={600} ta="center" c="dimmed">
                Wufoo
              </Text>
            </Table.Th>
            <Table.Th>
              <Text size="sm" fw={600} ta="center" c="dimmed">
                Formspree
              </Text>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {data.map((row, idx) => (
            <Table.Tr
              key={row.kind}
              style={{
                borderTop: idx === 0 ? '1px solid var(--mantine-color-gray-2)' : undefined,
                borderBottom:
                  idx < data.length - 1 ? '1px solid var(--mantine-color-gray-2)' : undefined,
              }}
            >
              <Table.Td>
                <Text size="sm" fw={500}>
                  {row.kind}
                </Text>
              </Table.Td>
              <Table.Td style={{ backgroundColor: 'rgba(10, 25, 47, 0.03)' }}>
                <CellContent value={row.rusty} highlight />
              </Table.Td>
              <Table.Td>
                <CellContent value={row.wufoo} />
              </Table.Td>
              <Table.Td>
                <CellContent value={row.formspree} />
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
      <Box px="lg" py="sm" style={{ borderTop: '1px solid var(--mantine-color-gray-2)' }}>
        <Text size="xs" c="dimmed" ta="center">
          Comparison based on entry-level plans
        </Text>
      </Box>
    </Card>
  );
}
